module.exports = __webpack_public_path__ + "img/4.59d42766.png";